import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

const beat = keyframes`
  0% { transform: scale(1); }
  25% { transform: scale(1.1); }
  50% { transform: scale(1); }
  75% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

const Heart = styled(motion.div)`
  width: 50px;
  height: 50px;
  background-color: ${(props) => props.theme.primaryColor};
  border-radius: 50%;
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1;
  animation: ${beat} 1.5s infinite;

  &::before,
  &::after {
    content: '';
    width: 50px;
    height: 50px;
    background-color: ${(props) => props.theme.primaryColor};
    border-radius: 50%;
    position: absolute;
  }

  &::before {
    top: -25px;
    left: 0;
  }

  &::after {
    left: 25px;
    top: 0;
  }
`;

function HeartAnimation() {
  return (
    <Heart
      initial={{ opacity: 0.8, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, repeat: Infinity, repeatType: 'reverse' }}
    />
  );
}

export default HeartAnimation;